import { render, staticRenderFns } from "./MutilSelectVcDemo.vue?vue&type=template&id=338fbcd3&scoped=true&"
import script from "./MutilSelectVcDemo.vue?vue&type=script&lang=js&"
export * from "./MutilSelectVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./MutilSelectVcDemo.vue?vue&type=style&index=0&id=338fbcd3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338fbcd3",
  null
  
)

export default component.exports